import { createFileRoute } from "@tanstack/react-router";
import { TemplatesManager } from "@/components/presentation/templates-manager.tsx";
import { m } from "@/paraglide/messages.js";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/settings/presentation-templates",
)({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.presentation_templates_my_title()) }],
	}),
});

function RouteComponent() {
	return <TemplatesManager scope="private" />;
}
